(()=>{ 'use strict';
  if(window.__lavindeMascaraCollectionV2)return;
  window.__lavindeMascaraCollectionV2=1;

  const injectUpsellPolish=()=>{
    let style=document.getElementById('lavinde-mascara-upsell-polish');
    if(!style){
      style=document.createElement('style');
      style.id='lavinde-mascara-upsell-polish';
      document.head.appendChild(style);
    }
    style.textContent=`
@media screen and (max-width:749px){
  .lavinde-mascara-v2 .lmv2-upsell{
    margin-top:0!important;
    transform-origin:top center;
  }
  .lavinde-mascara-v2 .lmv2-card-unit.is-upsell-open>.lavinde-mascara-card-v2{
    border-bottom-left-radius:0!important;
    border-bottom-right-radius:0!important;
  }
  .lavinde-mascara-v2 .lmv2-card-unit.is-upsell-open>.lmv2-upsell{
    margin-top:-1px!important;
    border-top:0!important;
    border-top-left-radius:0!important;
    border-top-right-radius:0!important;
  }
  .lavinde-mascara-v2 .lmv2-upsell.is-open{
    display:block!important;
    animation:lmv2UpsellDrop .36s cubic-bezier(.16,1,.3,1) both!important;
    will-change:transform,opacity,clip-path;
  }
}
.lavinde-mascara-v2 .lmv2-card__rating{
  display:block!important;
  width:100%!important;
  max-width:100%!important;
  text-align:left!important;
  justify-content:flex-start!important;
  align-items:center!important;
  margin-left:0!important;
  margin-right:auto!important;
  float:none!important;
}
.lavinde-mascara-v2 .lmv2-card__rating *,
.lavinde-mascara-v2 .lmv2-card__rating .jdgm-prev-badge__text,
.lavinde-mascara-v2 .lmv2-card__rating .spr-badge-caption,
.lavinde-mascara-v2 .lmv2-card__rating .product__rating__value,
.lavinde-mascara-v2 .lmv2-card__rating .product__rating__star,
.lavinde-mascara-v2 .lmv2-card__rating .product__rating__count{
  text-align:left!important;
}
.lavinde-mascara-v2 .lmv2-card__rating .product__rating,
.lavinde-mascara-v2 .lmv2-card__rating .jdgm-prev-badge,
.lavinde-mascara-v2 .lmv2-card__rating .spr-badge,
.lavinde-mascara-v2 .lmv2-card__rating .rating,
.lavinde-mascara-v2 .lmv2-card__rating .rating-wrapper{
  display:flex!important;
  justify-content:flex-start!important;
  align-items:center!important;
  width:100%!important;
  max-width:100%!important;
  margin-left:0!important;
  margin-right:auto!important;
  padding-left:0!important;
  float:none!important;
  text-align:left!important;
}
.lavinde-mascara-v2 .lmv2-card__rating .jdgm-prev-badge__stars,
.lavinde-mascara-v2 .lmv2-card__rating .spr-starrating,
.lavinde-mascara-v2 .lmv2-card__rating .rating-star,
.lavinde-mascara-v2 .lmv2-card__rating .product__rating__value{
  margin-left:0!important;
}
@keyframes lmv2UpsellDrop{
  0%{opacity:0;transform:translateY(-18px) scaleY(.94);clip-path:inset(0 0 100% 0)}
  55%{opacity:1}
  100%{opacity:1;transform:translateY(0) scaleY(1);clip-path:inset(0 0 0 0)}
}
@media (prefers-reduced-motion:reduce){
  .lavinde-mascara-v2 .lmv2-upsell.is-open{animation:none!important;clip-path:none!important;transform:none!important}
}`;
  };

  const forceRatingsLeft=(root=document)=>{
    const scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('.lavinde-mascara-v2 .lmv2-card__rating').forEach(rating=>{
      rating.style.setProperty('display','block','important');
      rating.style.setProperty('width','100%','important');
      rating.style.setProperty('max-width','100%','important');
      rating.style.setProperty('text-align','left','important');
      rating.style.setProperty('justify-content','flex-start','important');
      rating.style.setProperty('align-items','center','important');
      rating.style.setProperty('margin-left','0','important');
      rating.style.setProperty('margin-right','auto','important');
      rating.style.setProperty('float','none','important');

      rating.querySelectorAll('.product__rating,.jdgm-prev-badge,.spr-badge,.rating,.rating-wrapper').forEach(el=>{
        el.style.setProperty('display','flex','important');
        el.style.setProperty('justify-content','flex-start','important');
        el.style.setProperty('align-items','center','important');
        el.style.setProperty('width','100%','important');
        el.style.setProperty('max-width','100%','important');
        el.style.setProperty('margin-left','0','important');
        el.style.setProperty('margin-right','auto','important');
        el.style.setProperty('padding-left','0','important');
        el.style.setProperty('float','none','important');
        el.style.setProperty('text-align','left','important');
      });

      rating.querySelectorAll('.product__rating__value,.product__rating__star,.product__rating__count,.jdgm-prev-badge__stars,.jdgm-prev-badge__text,.spr-starrating,.spr-badge-caption').forEach(el=>{
        el.style.setProperty('text-align','left','important');
        el.style.setProperty('margin-left','0','important');
        el.style.setProperty('float','none','important');
      });
    });
  };

  let ratingObserver=null;
  const observeRatings=()=>{
    if(ratingObserver)return;
    ratingObserver=new MutationObserver(()=>forceRatingsLeft());
    ratingObserver.observe(document.documentElement,{childList:true,subtree:true});
  };

  const closeUpsellPanel=panel=>{
    if(!panel)return;
    panel.classList.remove('is-open');
    panel.hidden=true;
    const unit=panel.closest('[data-lmv2-card-unit]');
    if(unit)unit.classList.remove('is-upsell-open');
  };

  const showUpsell=(section,unit)=>{
    if(!section||!unit||section.dataset.lmv2UpsellEnabled==='false')return;
    if(!window.matchMedia('(max-width: 749px)').matches)return;
    const panel=unit.querySelector('[data-lmv2-upsell]');
    if(!panel)return;

    section.querySelectorAll('[data-lmv2-upsell].is-open').forEach(open=>{
      if(open!==panel)closeUpsellPanel(open);
    });

    unit.classList.add('is-upsell-open');
    panel.hidden=false;
    panel.classList.remove('is-open');
    void panel.offsetHeight;

    requestAnimationFrame(()=>{
      panel.classList.add('is-open');
      const rect=panel.getBoundingClientRect();
      if(rect.bottom>window.innerHeight||rect.top<80){
        panel.scrollIntoView({behavior:'smooth',block:'nearest'});
      }
    });
  };

  const init=root=>{
    injectUpsellPolish();
    const scope=root&&root.querySelectorAll?root:document;
    scope.querySelectorAll('[data-lmv2-products-section]').forEach(section=>{
      if(section.dataset.lmv2Ready==='true')return;
      section.dataset.lmv2Ready='true';

      const chips=[...section.querySelectorAll('[data-lmv2-filter-chip]')];
      const cards=[...section.querySelectorAll('[data-lmv2-product-card]')];
      const units=[...section.querySelectorAll('[data-lmv2-card-unit]')];
      const filterTargets=units.length?units:cards;

      chips.forEach(chip=>chip.addEventListener('click',()=>{
        const key=(chip.dataset.filterKey||'all').trim();
        chips.forEach(c=>{const on=c===chip;c.classList.toggle('is-active',on);c.setAttribute('aria-pressed',on?'true':'false')});
        filterTargets.forEach(target=>{
          const tags=(' '+(target.dataset.filterTags||'all')+' ').replace(/\s+/g,' ');
          const show=key==='all'||tags.indexOf(' '+key+' ')>-1;
          target.classList.toggle('lmv2-hidden',!show);
          if(!show){
            target.querySelectorAll('[data-lmv2-upsell].is-open').forEach(closeUpsellPanel);
          }
        });
        forceRatingsLeft(section);
      }));

      section.addEventListener('submit',event=>{
        const form=event.target;
        if(!form||form.closest('[data-lmv2-upsell]'))return;
        const card=form.closest('[data-lmv2-product-card]');
        if(!card)return;
        const unit=card.closest('[data-lmv2-card-unit]');
        window.setTimeout(()=>showUpsell(section,unit),700);
      });

      section.addEventListener('click',event=>{
        const button=event.target.closest('[data-add-to-cart]');
        if(!button||button.closest('[data-lmv2-upsell]'))return;
        const card=button.closest('[data-lmv2-product-card]');
        if(!card)return;
        const unit=card.closest('[data-lmv2-card-unit]');
        window.setTimeout(()=>showUpsell(section,unit),750);
      });

      forceRatingsLeft(section);
    });
    forceRatingsLeft(scope);
    window.setTimeout(()=>forceRatingsLeft(scope),100);
    window.setTimeout(()=>forceRatingsLeft(scope),500);
    observeRatings();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());
  else init();
  document.addEventListener('shopify:section:load',e=>setTimeout(()=>init(e.target),50));
})();